export default {"src":"/_next/static/image/public/images/ic_homecare_bg.e5596d7bb98472944d15e15ab926e741.svg","height":84,"width":84};